import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function Cart({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Cart_svg__Layer_1"
        viewBox="0 0 48 48"
        {...props}
      >
        <defs>
          <clipPath id="Cart_svg__clippath">
            <path
              d="M0 0h48v48H0z"
              style={{
                fill: 'none',
              }}
            />
          </clipPath>
          <style>
            {'.Cart_svg__st1{fill:none;stroke:#503291;stroke-width:1.5px}'}
          </style>
        </defs>
        <g
          style={{
            clipPath: 'url(#Cart_svg__clippath)',
          }}
        >
          <path
            d="M24 0c13.3 0 24 10.7 24 24S37.3 48 24 48 0 37.3 0 24 10.7 0 24 0"
            style={{
              fill: '#e2f4ff',
            }}
          />
          <path
            d="M10.2 13.4h5.5l.8 3.4s20.9-.2 21.2 0c.2.2-3.5 11.6-3.5 11.6H18.7c-2.2 0-2.5 2.9 0 3.2h15.8"
            style={{
              fill: 'none',
              stroke: '#503291',
              strokeWidth: '1.5px',
              strokeLinecap: 'round',
            }}
          />
          <path
            d="M15.5 13 19 28.2M20.8 37.9c1 0 1.9-.9 1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9 1.9.9 1.9 1.9 1.9ZM31.7 37.9c1 0 1.9-.9 1.9-1.9s-.9-1.9-1.9-1.9-1.9.9-1.9 1.9.9 1.9 1.9 1.9Z"
            className="Cart_svg__st1"
          />
        </g>
      </svg>
    </Icon>
  )
}
export default Cart
